import Service from "../../service";

const TransportType = {
    getTransportType() {
        return Service.get("/transport_type");
    },
    showTransportType(id) {
        return Service.get("/transport_type/" + id);
    }
};

export default TransportType;
